import { useContext } from 'react'
import { useSelector } from 'react-redux'

import {
  useForm, useLatestEntity, useThunkDispatch,
} from '@domain-group/react-hooks'

import { launchModal, mergeAndStringifyEntityObjects } from '@domain-group/javascript-utils'

import defaultState, { requiredFields } from '@models/providerOrderCode'

import * as providerOrderCodeActions from '@redux/modules/providerOrderCode'

import PageContext from '@contexts/pageContext'

const createProviderOrderCode = (params) => {
  const { providerOrderCodeParams, dispatch, requestOptions = {} } = params

  const { createProviderOrderCode: createFn } = providerOrderCodeActions

  const updatedParams = mergeAndStringifyEntityObjects({}, providerOrderCodeParams, [], ['options'])

  return dispatch(createFn(updatedParams, requestOptions))
}

const updateProviderOrderCode = (params) => {
  const {
    providerOrderCode, providerOrderCodeParams, dispatch, requestOptions = {},
  } = params

  const { updateProviderOrderCode: updateFn } = providerOrderCodeActions

  const updatedParams = mergeAndStringifyEntityObjects(providerOrderCode, providerOrderCodeParams, [], ['options'])

  return dispatch(updateFn(updatedParams, requestOptions))
}

const deleteProviderOrderCode = (params) => {
  const { providerOrderCode, dispatch } = params
  const { deleteProviderOrderCode: deleteFn } = providerOrderCodeActions

  return dispatch(deleteFn(providerOrderCode))
}

export function useRelations(providerOrderCode = {}){
  const {
    provider_price_list_id,
    service_product_id,
  } = providerOrderCode

  const {
    providerPriceLists,
    serviceProducts,
  } = useSelector(reduxState => reduxState.entities)

  const providerPriceList = providerPriceLists[provider_price_list_id] || {}
  const serviceProduct = serviceProducts[service_product_id] || {}

  return {
    providerPriceList,
    serviceProduct,
  }
}

export function useProviderOrderCodeForm(providerOrderCode = {}, options = {}){
  const { validateOn } = options

  const providerOrderCodeForm = useForm(
    defaultState,
    { entity: providerOrderCode, requiredFields, validateOn },
    [providerOrderCode.id, providerOrderCode.cache_key],
  )

  return {
    ...providerOrderCodeForm,
  }
}

function useProviderOrderCode(initEntity = {}){
  const { entity: providerOrderCode } = useLatestEntity(initEntity, 'providerOrderCodes')

  const { callbacks } = useContext(PageContext)

  const { creating, updating } = useSelector(reduxState => reduxState.providerOrderCodes)

  const dispatch = useThunkDispatch()

  const { providerPriceList, serviceProduct } = useRelations(providerOrderCode)

  return {
    callbacks: {
      createOrEditProviderOrderCode: () => launchModal({
        callbacks,
        modalKey: 'CreateOrEditProviderOrderCodeModal',
        payload: {
          providerOrderCode,
        },
      }),
      createProviderOrderCode: (providerOrderCodeParams, requestOptions) => createProviderOrderCode({
        providerOrderCodeParams, dispatch, requestOptions,
      }),
      deleteProviderOrderCode: () => deleteProviderOrderCode({ providerOrderCode, dispatch }),
      updateProviderOrderCode: (providerOrderCodeParams, requestOptions) => updateProviderOrderCode({
        providerOrderCode, providerOrderCodeParams, dispatch, requestOptions,
      }),
    },
    creating,
    providerOrderCode,
    providerPriceList,
    serviceProduct,
    updating,
  }
}

export default useProviderOrderCode
